import React, { useEffect, useRef, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import { useTranslation } from 'react-i18next'
import { getmyevents, getnearby } from '../../utils/api'
import { gettime } from '../../utils/time'
import { getSourceMapRange } from 'typescript';
import { get } from 'lodash';
import { useSearchParams, useParams } from 'react-router-dom'
import axios from 'axios';
import { Toast } from 'zarm';
import { Flex } from 'antd';
import dw2 from '../../static/img/dw2.png';
import dqwz from '../../static/img/dqwz.png';
import {key} from './key';

const Plat: React.FC = () => {
  const { t } = useTranslation()
  const [map, setMap] = useState<google.maps.Map>();
  const [directions, setDirections] = useState<google.maps.DirectionsResult>(); const mapRef = useRef<HTMLDivElement>(null);
  const [center, setCenter] = useState({ lat: 37.77559046201275, lng: -122.42160803531742 });
  const [search, setsearch] = useSearchParams()
  // const nameLocation = search.get("eventName") + ',' + search.get("eventLocation")
  const [distance, setdistance] = useState() as any
  const [drivingtime, setdrivingtime] = useState() as any
  const [activity, setactivity] = useState() as any


  let activityRef = useRef()
  useEffect(() => {
    activityRef.current = activity
  }, [activity])

  const [Travelmode, setTravelmode] = useState('Drive')


  const [upcoming, getupcoming] = useState([]) as any;





  // const Directions = (lat: any, lng: any, type: number) => {
  //   // const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  //   // window.location.assign(url);



  //   const loader = new Loader({
  //     apiKey: 'AIzaSyD5wXIHjnMZKy3RAPMGw6fzLUR81WlEVmk',
  //     version: 'weekly',
  //     // language:'en-US'
  //   });


  //   let travelMode = google.maps.TravelMode.DRIVING
  //   if (type == 1) {
  //     travelMode = google.maps.TravelMode.DRIVING
  //   } else if (type == 2) {
  //     travelMode = google.maps.TravelMode.TRANSIT
  //   } else if (type == 3) {
  //     travelMode = google.maps.TravelMode.BICYCLING
  //   } else if (type == 4) {
  //     travelMode = google.maps.TravelMode.WALKING
  //   }

  //   loader.load().then(() => {
  //     // Try HTML5 geolocation.
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         (position: GeolocationPosition) => {
  //           const pos = {
  //             lat: position.coords.latitude,
  //             lng: position.coords.longitude,
  //           };


  //           const directionsService = new google.maps.DirectionsService();
  //           const directionsRenderer = new google.maps.DirectionsRenderer({
  //             map,
  //           });


  //           console.log(lat,lng)

  //           directionsService.route(
  //             {
  //               origin: { lat: pos.lat, lng: pos.lng, },
  //               destination: { lat: lat, lng: lng },
  //               travelMode: travelMode,
  //               // travelMode: google.maps.TravelMode.BICYCLING,
  //               // travelMode: google.maps.TravelMode.DRIVING,
  //               // travelMode: google.maps.TravelMode.TRANSIT,
  //               // travelMode: google.maps.TravelMode.WALKING,
  //             },
  //             (result, status) => {

  //               if (status === google.maps.DirectionsStatus.OK) {
  //                 setdistance(result.routes[0].legs[0].distance.text)
  //                 setdrivingtime(result.routes[0].legs[0].duration.text)
  //                 directionsRenderer.setDirections(result);
  //                 setDirections(result);
  //               } else {
  //                 setdistance('Sorry, no travel method results were found')
  //                 setdrivingtime('')
  //               }
  //             }
  //           );



  //         },
  //         (e) => {
  //           console.log(e)
  //         }
  //       );
  //     } else {
  //       // Browser doesn't support Geolocation
  //     }

  //   });

  // };

  const [sdmUserId, setsdmUserId] = useState('');
  let sdmUserIdref = useRef('')
  useEffect(() => {
    sdmUserIdref.current = sdmUserId
  }, [sdmUserId])


  const goBackPage = () => {
    window.history.back()
  }


  function handleLocationError(
    browserHasGeolocation: boolean,
    infoWindow: google.maps.InfoWindow,
    pos: google.maps.LatLng
  ) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(
      browserHasGeolocation
        ? "Error: The Geolocation service failed."
        : "Error: Your browser doesn't support geolocation."
    );
    infoWindow.open(map);
  }


  const parmas = useParams()
  const mapdata: any = parmas.item
  const datamap = JSON.parse(mapdata)

  const getDate = () => {


    const pos: any = [{
      lat: Number(datamap.latitude),
      lng: Number(datamap.longitude)
    }]

    const data: any = []
    let name =
      '<div id="content">' +
      '<div id="siteNotice">' +
      "</div>" +
      '<h2 id="firstHeading" class="firstHeading">' + datamap.eventName + '</h2>' +
      '<div id="bodyContent">' +
      "<p>" + datamap.time + "</p>" +
      '<p>' + datamap.eventLocation + "</p>" +
      "</div>" +
      "</div>";

    data[0] = pos
    data[0].push(name)
    data[0].push(datamap.eventName)
    setactivity(data)

    getmaps(data, null, null, null)
  }


  const [Allactivities, setAllactivities] = useState([]) as any;
  const AllactivitiesRef = useRef(Allactivities);

  useEffect(() => {
    AllactivitiesRef.current = Allactivities
  }, [Allactivities])


  const allmap = () => {

    const data: any = []
    console.log(AllactivitiesRef.current)
    if (AllactivitiesRef.current.length > 0) {
      AllactivitiesRef.current.forEach((item2: any, index: number) => {
        const pos: any = [{
          lat: Number(item2.latitude),
          lng: Number(item2.longitude)
          // lat:39.553821416288656,
          // lng: -123.4306059757350
        }]
        let name =
          '<div id="content">' +
          '<div id="siteNotice">' +
          "</div>" +
          '<h2 id="firstHeading" class="firstHeading">' + item2.eventName + '</h2>' +
          '<div id="bodyContent">' +
          "<p>" + item2.time + "</p>" +
          '<p>' + item2.eventLocation + "</p>" +
          "</div>" +
          "</div>";

        data[index] = pos
        data[index].push(name)
        data[index].push(item2.eventName)
      })

      activityRef.current = data
      setactivity(activityRef.current)
      getmaps(data, Number(AllactivitiesRef.current[0].latitude), Number(AllactivitiesRef.current[0].longitude), null)
    } else {
      Toast.show(t('Therearenoactivitiesnearby'));
    }
  }

  const getAllactivities = () => {
    getnearby(datamap.eventId, 100, sdmUserIdref.current).then((res) => {
      AllactivitiesRef.current = res.data

      AllactivitiesRef.current.forEach((item:any)=>{
        item.time = gettime(item.eventStartTime, item.eventEndTime)
      })

      setAllactivities(AllactivitiesRef.current)
    })

  }


  const getDistances = (lat1: any, lng1: any, lat2: any, lng2: any) => {
    let EARTH_RADIUS = 6378.137;// 地球半径
    let radLat1 = lat1 * Math.PI / 180.0; //lat1 * Math.PI / 180.0=>弧度计算
    let radLat2 = lat2 * Math.PI / 180.0;
    let a = radLat1 - radLat2;
    let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
    let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000;// 输出为公里
    // return Number(s.toFixed(2))  
  }




  const getmaps = (data: any, lat: any | null, lng: any | null, type: number | null) => {

    const loader = new Loader({
      apiKey: key,
      version: 'weekly',
      language: 'en-US'
    });

    loader.load().then(() => {
      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position: GeolocationPosition) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };


            let longitude = 0
            let latitude = 0

            if (lat && lng) {
              longitude = lng
              latitude = lat
            } else {
              longitude = Number(datamap.longitude)
              latitude = Number(datamap.latitude)
            }

            const positions = {
              lat: latitude,
              lng: longitude
            }



            const google = window.google;
            const map = new google.maps.Map(mapRef.current!, {
              center: { lat: latitude, lng: longitude, },
              zoom: 15,
              // gestureHandling: "cooperative",
              // language:'en'
            });
            setMap(map);

            const bounds = new google.maps.LatLngBounds();
            const directionsService = new google.maps.DirectionsService();
            const directionsRenderer = new google.maps.DirectionsRenderer({
              map,
              suppressMarkers: true
            });

            if (type) {
              let travelMode = google.maps.TravelMode.DRIVING
              if (type == 1) {
                setTravelmode('Drive')
                travelMode = google.maps.TravelMode.DRIVING
              } else if (type == 2) {
                setTravelmode('Take bus')

                travelMode = google.maps.TravelMode.TRANSIT
              } else if (type == 3) {
                setTravelmode('RIDE')
                travelMode = google.maps.TravelMode.BICYCLING
              } else if (type == 4) {
                setTravelmode('Walk')
                travelMode = google.maps.TravelMode.WALKING
              }





              setCenter(positions)
              console.log(data[0][1], '11111')
              directionsService.route(
                {
                  origin: { lat: pos.lat, lng: pos.lng, },
                  destination: { lat: latitude, lng: longitude },
                  travelMode: travelMode
                },
                (result, status) => {
                  console.log(result)
                  if (status === google.maps.DirectionsStatus.OK) {


                    const marker2 = new MarkerWithLabel({
                      position: { lat: pos.lat, lng: pos.lng, },
                      draggable: false, //不可拖动
                      map: map, //地图实例
                      icon: dqwz,
                    });




                    result.routes[0].legs[0].end_address = data[0][1]
                    setdistance(result.routes[0].legs[0].distance.text)
                    setdrivingtime(result.routes[0].legs[0].duration.text)
                    directionsRenderer.setDirections(result);


                    setDirections(result);
                  } else {
                    setdistance('Sorry, no travel method results were found')
                    setdrivingtime('')
                  }
                }
              );

            }
            var MarkerWithLabel = require("markerwithlabel")(google.maps);


            getDistances(latitude, longitude, pos.lat, pos.lng)

            const tourStops: [google.maps.LatLngLiteral, string, string][] = data
            const infoWindow = new google.maps.InfoWindow();

            tourStops.forEach(([position, title, name], i) => {
              bounds.extend(new google.maps.LatLng(position.lat, position.lng));
              console.log(title)
              // const marker: any = new google.maps.Marker({
              //   position,
              //   map,
              //   title: title,
              //   optimized: false,
              // });
              const marker = new MarkerWithLabel({
                position,
                title: title,
                draggable: false, //不可拖动
                map: map, //地图实例
                labelContent: name, //label的内容
                icon: dw2,
                labelAnchor: new google.maps.Point(-15, 35),
                labelStyle: {
                  padding: "5px 10px",
                  textAlign: "center",
                  fontWeight: '900',
                  color: 'rgb(85,137,195)',
                  // height:'30px',
                  // lineHeight:'30px',
                  border: '2px solid rgb(85,137,195)',
                  borderRadius: '5px',
                  backgroundColor: 'rgba(255,255,255,0.7)',
                  width: '120px',
                  opacity: 1
                },
              });

              marker.addListener("click", () => {
                console.log(position)
                setCenter(position)

                directionsService.route(
                  {
                    origin: { lat: pos.lat, lng: pos.lng, },
                    destination: { lat: position.lat, lng: position.lng },
                    travelMode: google.maps.TravelMode.DRIVING,
                  },
                  (result, status) => {
                    if (status === google.maps.DirectionsStatus.OK) {

                      const marker2 = new MarkerWithLabel({
                        position: { lat: pos.lat, lng: pos.lng, },
                        draggable: false, //不可拖动
                        map: map, //地图实例
                        icon: dqwz,
                      });


                      result.routes[0].legs[0].end_address = title
                      setdistance(result.routes[0].legs[0].distance.text)
                      setdrivingtime(result.routes[0].legs[0].duration.text)
                      directionsRenderer.setDirections(result);
                      map.fitBounds(bounds);
                      // marker.setMap(null);
                      setDirections(result);
                    } else {
                      setdistance('Sorry, no travel method results were found')
                      setdrivingtime('')
                    }
                  }
                );

                infoWindow.close();
                infoWindow.setContent(marker.getTitle());
                infoWindow.open(marker.getMap(), marker);
              });
            });

            map.fitBounds(bounds);
          },
          (e) => {
            console.log(e)
          }
        );
      } else {
        // Browser doesn't support Geolocation
      }

    });
  }




  useEffect(() => {
    window.scrollTo(0, 0);
    let data3: any = []
    data3 = localStorage.getItem('userinformation')
    data3 = JSON.parse(data3)
    sdmUserIdref.current = data3.userId

    getAllactivities()
    getDate()
  }, []);

  return <div style={{ height: '100vh', width: '100%', position: 'relative' }} >
    <div style={{
      backgroundColor: '#202225', width: '100%', height: '60px', display: 'flex', flexDirection: 'row',
      justifyContent: 'space-between', borderBottomColor: '#4747474D', borderBottomWidth: 1, zIndex: 9999,
      position: 'fixed', alignItems: 'center'
    }}>
      <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', alignItems: 'center' }}>
        <img src={require("../../static/img/xljt.png")} style={{ width: '24px', height: '24px', marginRight: '10px' }} onClick={() => goBackPage()}></img>
        <div style={{ lineHeight: '60px', fontSize: '18px', fontWeight: 500, color: '#fff', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '60vw' }}>{datamap.eventName}</div>
      </div>
      <img src={require("../../static/img/map.png")} style={{ width: '24px', height: '24px', marginRight: '10px' }} onClick={() => allmap()} ></img>
    </div>




    <div ref={mapRef} style={{ height: '95vh', width: '100%', position: 'relative' }} >

    </div>
    {/* <div onClick={() => Directions(center.lat, center.lng)} style={{ position: 'absolute', top: '20px', left: '20px', zIndex: 9999, padding: '20px', backgroundColor: '#FfF' }}>
      开始导航
    </div> */}
    {
      distance &&
      <div style={{ backgroundColor: '#fff', zIndex: 999, width: '100%', padding: '20px', position: 'fixed', bottom: 0 }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ marginBottom: '10px', fontSize: '18px', fontWeight: 500 }}>{Travelmode} : {distance}</div>
          {drivingtime != '' &&
            <div style={{ marginBottom: '10px', fontSize: '18px', fontWeight: 500, marginLeft: '10px' }}>{drivingtime}</div>
          }
        </div>


        <div style={{ display: 'flex', flexDirection: 'row', overflowX: 'scroll', width: '90%', cursor: 'pointer' }}>
          <div onClick={() => getmaps(activity, center.lat, center.lng, 1)} style={{
            height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
            backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
          }}>{t('Drive')}</div>
          <div onClick={() => getmaps(activity, center.lat, center.lng, 2)} style={{
            height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
            backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
          }}>{t('Takebus')}</div>
          <div onClick={() => getmaps(activity, center.lat, center.lng, 3)} style={{
            height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
            backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
          }}>{t('RIDE')}</div>
          <div onClick={() => getmaps(activity, center.lat, center.lng, 4)} style={{
            height: '24px', lineHeight: '14px', fontSize: '14px', padding: '5px', borderRadius: '22px',
            backgroundColor: '#00aaff', color: '#fff', textAlign: 'center', flex: 1, marginRight: '5px'
          }}>{t('Walk')}</div>
        </div>
      </div>
    }


  </div>;
};

export default Plat;



